Ext.define('SA.view.RenameMenu', {
    alias: 'widget.rename-menu',
    extend: 'SA.view.ArrowMenu',

    alignment: 'bottom',
    autoShow: true,
    behaveAsWindow: true,
    maxLength: 30,
    width: 300,

    initComponent() {
        var name = this.name;

        this.items = [
            {
                xtype: 'simple-container',
                cls: 'sa-rename-menu-body',

                items: [
                    {
                        xtype: 'component',
                        cls: 'sa-rename-menu-label',
                        html: 'Rename:'
                    }, {
                        xtype: 'sa-text-field',
                        cls: 'sa-rename-menu-input',
                        height: 33,
                        maxLength: this.maxLength,
                        value: name,

                        listeners: {
                            scope: this,

                            enterkeypress: this.destroy,
                            esckeypress: this.destroy,

                            beforedestroy: field => {
                                var value = field.getValue().trim();

                                if (value !== name) {
                                    Ext.callback(this.handler, this.scope, [value]);
                                }
                            },

                            boxready(field) {
                                field.select();
                            }
                        }
                    }
                ]
            }
        ];

        this.callParent();
    }
});